import React from 'react';
import { Typography, Container, Link } from '@mui/material';
import styled from '@emotion/styled'; 

const FooterContainer = styled(Container)`
  padding: 20px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Footer: React.FC = () => {
  return (
    <FooterContainer maxWidth="md">
      <Typography variant="body1" color="textPrimary" align="center">
          &copy; {new Date().getFullYear()} iMowazi All rights reserved
      </Typography> 
    </FooterContainer>
  );
};

export default Footer;
